var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIcGoogle = function SvgIcGoogle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M15.037 8.154a8 8 0 0 0-.115-1.355H8.634v2.567h3.6c-.149.828-.629 1.56-1.332 2.026v1.666h2.149c1.261-1.161 1.986-2.876 1.986-4.904"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M8.633 14.667c1.798 0 3.315-.59 4.42-1.61l-2.149-1.665c-.598.407-1.37.637-2.268.637-1.74 0-3.214-1.174-3.743-2.751H2.676v1.717a6.67 6.67 0 0 0 5.957 3.672"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M4.89 9.278a4 4 0 0 1 0-2.553V5.008H2.676a6.67 6.67 0 0 0 0 5.987z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M8.633 3.972a3.62 3.62 0 0 1 2.558 1l1.903-1.904a6.4 6.4 0 0 0-4.46-1.734 6.67 6.67 0 0 0-5.958 3.674L4.89 6.725c.527-1.58 2.004-2.753 3.743-2.753"
  })));
};
export default SvgIcGoogle;